export var NotificationEntryTypeEnum;
(function (NotificationEntryTypeEnum) {
    NotificationEntryTypeEnum[NotificationEntryTypeEnum["Info"] = 1] = "Info";
    NotificationEntryTypeEnum[NotificationEntryTypeEnum["Success"] = 2] = "Success";
    NotificationEntryTypeEnum[NotificationEntryTypeEnum["Warning"] = 3] = "Warning";
    NotificationEntryTypeEnum[NotificationEntryTypeEnum["Error"] = 4] = "Error";
    NotificationEntryTypeEnum[NotificationEntryTypeEnum["Reminder"] = 5] = "Reminder";
    NotificationEntryTypeEnum[NotificationEntryTypeEnum["VideoCall"] = 6] = "VideoCall";
    NotificationEntryTypeEnum[NotificationEntryTypeEnum["WorkflowAssignment"] = 7] = "WorkflowAssignment";
})(NotificationEntryTypeEnum || (NotificationEntryTypeEnum = {}));
